<template>
  <div>
    <div v-if="visible">
      <div class="text-h1 mb-15">
        {{ titleCard }}
      </div>
      <vz-order-create-direction-special-requirements-preview :value="value" :purpose="purpose" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ISpecialRequirements } from '~/types/order/order'
import { Purpose } from '~/types/order/order';
import {OrderForm, OrderSpecialRequirement} from '~/types/types';
import VzOrderCreateDirectionSpecialRequirementsPreview from "~/components/personal/order/vz-order-create-direction-special-requirements-preview.vue"
import {PropType} from 'vue';

const props = defineProps({
  directionTo: {
    type: Boolean,
    default: false
  },
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  }
})

const purpose = computed((): Purpose => {
  return props.directionTo ? 'destination' : 'dispatch'
})

const requirements = computed((): OrderSpecialRequirement => {
  return props.order?.specialRequirements?.[purpose.value]
})

const value = computed((): ISpecialRequirements => {
  return {
    bodyHeight_2: requirements.value.bodyHeight_2 || false,
    bodyHeight_2_1: requirements.value.bodyHeight_2_1 || false,
    bodyHeight_2_2: requirements.value.bodyHeight_2_2 || false,
    bodyHeight_2_3: requirements.value.bodyHeight_2_3 || false,
    bodyHeight_2_4: requirements.value.bodyHeight_2_4 || false,
    bodyHeight_2_5: requirements.value.bodyHeight_2_5 || false,
    ramp110: requirements.value.ramp110 || false,
    ramp120: requirements.value.ramp120 || false,
    ramp130: requirements.value.ramp130 || false,
    width210: requirements.value.width210 || false,
    width220: requirements.value.width220 || false,
    driverComment: requirements.value.driverComment.active,
    driverCommentValue: requirements.value.driverComment.value,
    hasEntryFee: requirements.value.entryFee.value,
    roadmap: requirements.value.roadmap.active,
    driverData: requirements.value.driverData.active,
    driverDataValue: requirements.value.driverData.value,
    documentAddress: requirements.value.documentAddress.active,
    documentAddressValue: requirements.value.documentAddress.value,
    unloadingOperations: requirements.value.unloadingOperations.active,
    unloadingOperationsValue: requirements.value.unloadingOperations,
    fixingStraps: requirements.value.fixingStraps || false,
    passportRF: requirements.value.passportRF || false,
    reflectiveVest: requirements.value.reflectiveVest || false,
    closedClothes: requirements.value.closedClothes || false,
    medicalCard: requirements.value.medicalCard || false,
    emptyMachine: requirements.value.emptyMachine || false,
    pallets: requirements.value.pallets || false,
    rearLoading: requirements.value.rearLoading || false,
    sanitaryPassport: requirements.value.sanitaryPassport || false,
    type: requirements.value.type as ISpecialRequirements['type'],
    emptyMachineCost: 0,
    typeLateralLoadCost: 0,
    typeTopLoadCost: 0,
    typeTailLiftCost: 0,
    typeManipulatorCost: 0,
    typeOpenMachineCost: 0,
    typeRemovableCurtainsCost: 0
  }
})

const visible = computed((): boolean => {
  return Object.entries(value.value)
    .filter(([key, value]) => value && !['unloadingOperationsValue', 'type'].includes(key))
    .length > 0
})

const titleCard = computed((): string => {
  return props.directionTo ? 'Отвоз груза' : 'Забор груза'
})

defineExpose({
  visible
})
</script>
